mutation NotifyTimeActivation($input: NotifyTimeActivationInput!) {
  notifyTimeActivation(input: $input) {
    activatedEntities {
      id
      rowTimestamp
    }
  }
}